<mat-panel-title class="primary-text" style="width: 100%">
	<table *ngIf="!utilService.isNullOrUndefined(searchResult)" class="full-width" fxFlex="100">
		<tr fxLayout="row">
			<td
				#businessNameContainer
				fxFlex
				fxLayout="row"
				fxLayoutAlign="space-between center"
				class="p-r-1"
			>
				<div fxLayout="row">
					<div
						[ngStyle]="{
							'max-width':
								'calc(' +
								(businessNameContainer?.offsetWidth
									? businessNameContainer.offsetWidth -
										(20 +
											(SHOW_ONBOARD_CARRIER_LINK(
												CARRIER_QUALITY_ENABLED,
												carrierVettingService,
												searchResult?.vettingSource,
												searchResult.customerCarrier,
												searchResult.firmDot,
												isCarrierVettingIntegrationEnabled,
												searchResult.vettingSourceId,
												isCarrierOnboarded
											)
												? 90
												: 16))
									: 240) +
								'px)'
						}"
						class="ellipsis"
					>
						<b *ngIf="searchResult.customerCarrier" class="font-size-16">
							{{ searchResult.businessName }}
						</b>
						<span *ngIf="!searchResult.customerCarrier" class="font-size-16">
							{{ searchResult.businessName }}
						</span>
					</div>
					<div
						*ngIf="
							SHOW_IN_NETWORK_LOGO(
								CARRIER_QUALITY_ENABLED,
								searchResult.firmDot,
								isCarrierVettingIntegrationEnabled,
								searchResult?.vettingSource,
								searchResult.vettingSourceId,
								carrierVettingService,
								searchResult.carrierId,
								searchResult.customerCarrier
							)
						"
						fxLayoutAlign="start center"
					>
						<img
							[src]="carrierVettingService.logo(searchResult?.vettingSource)"
							[matTooltip]="
								carrierVettingService.tooltip(
									searchResult?.vettingSource,
									searchResult?.carrierOnboardedOn
								)
							"
							class="h-18 in_network_logo"
						/>
					</div>
					<img
						*ngIf="searchResult?.haulPayApproved && environment.SHOW_QUALITY"
						class="carrier_header_icons"
						[src]="haulpayService.logo()"
						[matTooltip]="haulpayService.tooltip()"
					/>
				</div>
				<span
					*ngIf="
						SHOW_ONBOARD_CARRIER_LINK(
							CARRIER_QUALITY_ENABLED,
							carrierVettingService,
							searchResult?.vettingSource,
							searchResult.customerCarrier,
							searchResult.firmDot,
							isCarrierVettingIntegrationEnabled,
							searchResult.vettingSourceId,
							isCarrierOnboarded
						)
					"
					class="link ml-6 font-size-12"
					fxLayoutAlign="end center"
					(click)="$event.stopImmediatePropagation(); onboardCarrier()"
				>
					Onboard Carrier
				</span>
			</td>
			<td fxFlex="20" fxLayoutAlign="start center">
				<div
					class="full-width p-r-1"
					(click)="$event.stopPropagation()"
					fxLayoutAlign="space-between center"
					*ngIf="accountSettings.CARRIER_QUALITY"
				>
					<span class="font-size-14 font-weight-bold">Quality Score: </span>
					<span
						class="font-size-14 font-weight-bold {{
							getCcScoreDisplay(searchResult.ccScore) || 'N/A'
						}}"
						>{{ getCcScoreDisplay(searchResult.ccScore) || 'N/A' }}</span
					>
				</div>
			</td>
			<td fxFlex="21" fxLayoutAlign="start center">
				<div
					class="full-width"
					(click)="$event.stopPropagation()"
					fxLayoutAlign="space-between center"
				>
					<span
						class="font-size-14"
						[style.fontWeight]="filters.column == RANGE_FILTERS.SORT.MATCH ? 'bold' : 'normal'"
					>
						Match Confidence
					</span>
					<span class="font-size-14 font-weight-bold success-text">
						<meter
							high="66"
							low="33"
							max="100"
							min="0"
							optimum="90"
							value="{{ searchResult.match }}"
							[matTooltip]="searchResult.match"
							matTooltipClass="custom-tooltip"
						></meter>
					</span>
				</div>
			</td>
			<td fxFlex="20"></td>
			<td fxFlex="11">
				<div
					class="full-width"
					*ngIf="
						productsService.ASSIGN_CARRIERS &&
						!utilService.isNullOrUndefined(usersList) &&
						usersList.length > 0 &&
						!utilService.isNullOrUndefined(userCarrierMapList)
					"
				>
					<app-user-selector
						(userChanged)="setAssignee($event, searchResult.carrierId)"
						[selectedUsers]="
							utilService.isNullOrUndefined(userCarrierMap[searchResult.carrierId])
								? []
								: [getUserIdAssigned(searchResult.carrierId)]
						"
						[showAssignMe]="false"
						[singleselect]="true"
						[usersList]="usersList"
						customCssClass="custom-form-field assignn_rep_max_width"
						floatLabel="never"
						fxFlex
						placeholder="Assign Rep"
					></app-user-selector>
				</div>

				<span
					(click)="
						$event.stopPropagation();
						panelClicked.emit({ search: searchResult, mouseEvent: $event })
					"
					*ngIf="isMultiselectEnabled"
					class="selection"
					matTooltip
				>
					<mat-icon>check_circle</mat-icon>
				</span>
				<span
					(click)="
						$event.stopPropagation();
						panelClicked.emit({ search: searchResult, mouseEvent: $event })
					"
					*ngIf="addCarriersToProject"
					[ngStyle]="{
						color: selectedCarrierIds.indexOf(searchResult.carrierId) == -1 ? 'grey' : '#103459'
					}"
					class="selection-right"
					matTooltip
				>
					<mat-icon>check_circle</mat-icon>
				</span>
			</td>
		</tr>

		<tr class="font-size-14 mt-3" fxLayout="row">
			<td fxFlex fxLayoutAlign="start center">
				<div (click)="$event.stopPropagation()" fxLayoutAlign="end center">
					<span
						*ngIf="
							!utilService.isNullOrUndefined(searchResult.firmDot) ||
							!utilService.isNullOrUndefined(searchResult.firmMc)
						"
						class="font-size-14"
					>
						<span
							(click)="utilService.copyToClipboard(searchResult.firmMc, COPY_TO_CLIPBOARD_MSGS.MC)"
							*ngIf="!utilService.isNullOrUndefined(searchResult.firmMc)"
						>
							MC: {{ searchResult.firmMc }}
						</span>
						{{
							!utilService.isNullOrUndefined(searchResult.firmDot) &&
							!utilService.isNullOrUndefined(searchResult.firmMc)
								? ' / '
								: ''
						}}
						<span
							(click)="
								utilService.copyToClipboard(searchResult.firmDot, COPY_TO_CLIPBOARD_MSGS.DOT)
							"
							*ngIf="!utilService.isNullOrUndefined(searchResult.firmDot)"
						>
							DOT: {{ searchResult.firmDot }}
						</span>
					</span>
				</div>
			</td>
			<td fxFlex="20" fxLayoutAlign="start center">
				<div class="full-width p-r-1" fxLayoutAlign="space-between center">
					<span>Authority:</span>
					<span>{{ searchResult?.authorityGrantDate || '' }}</span>
				</div>
			</td>
			<td fxFlex="21" fxLayoutAlign="start center">
				<div class="full-width" fxLayoutAlign="start center" *ngIf="searchResult.isLane">
					<span>Lane:&nbsp;</span>
					<span
						class="font-size-12 truncate_text"
						[appTruncateTooltip]="
							searchResult.lanePath +
								(!utilService.isNullOrUndefined(LANE_TRAILER_TYPE)
									? '(' + LANE_TRAILER_TYPE + ')'
									: '') || ''
						"
					>
						{{ searchResult.lanePath }}
						{{
							!utilService.isNullOrUndefined(LANE_TRAILER_TYPE) ? '(' + LANE_TRAILER_TYPE + ')' : ''
						}}
					</span>
				</div>
				<span *ngIf="isSearchResultOnlyTruck()">{{ searchResult.location }}</span>
				<span *ngIf="searchResult.isTruckAndLane">
					<img height="18px" src="./assets/icons/delivery-truck.svg" style="margin: 0 6px -4px 0" />
				</span>
			</td>
			<td fxFlex="20">
				<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
					<span>Last Contact:</span>
					<span>
						{{
							!utilService.isNullOrUndefined(searchResult.recentFeedbackDate)
								? DATE_MDY(searchResult.recentFeedbackDate)
								: 'N/A'
						}}
					</span>
				</div>
			</td>
			<td fxFlex="11" fxLayoutAlign="start center">
				<mat-spinner
					*ngIf="utilService.isNullOrUndefined(searchResult.lanesCount)"
					[diameter]="11"
					strokeWidth="1"
				></mat-spinner>
				<div
					class="full-width"
					*ngIf="!utilService.isNullOrUndefined(searchResult.lanesCount)"
					(click)="$event.stopPropagation(); showFullProfile()"
					fxLayoutAlign="space-between center"
				>
					<span>
						{{ searchResult.lanesCount + ' Lane' + (searchResult.lanesCount > 1 ? 's' : '') }}
					</span>
					<span fxLayoutAlign="start center">
						<img class="ml-4" height="18px" src="./assets/icons/road.svg" />
					</span>
				</div>
			</td>
		</tr>

		<tr class="font-size-14 mt-3" fxLayout="row">
			<td fxFlex fxLayoutAlign="start center">
				<span
					*ngIf="IS_NOT_EMPTY(searchResult.carrierHQ)"
					[style.fontWeight]="
						!utilService.isNullOrUndefined(filters.carrierHQ) && filters.carrierHQ.length > 2
							? 'bold'
							: 'normal'
					"
				>
					HQ: {{ searchResult.carrierHQ }}
					<span *ngIf="!utilService.isNullOrUndefined(searchResult.distance)" class="primary-text">
						({{ searchResult.distance }} miles)
					</span>
				</span>
			</td>
			<td fxFlex="20" fxLayoutAlign="start center">
				<div class="full-width p-r-1" fxLayoutAlign="space-between center">
					<span>Cargo Ins:</span>
					<span *ngIf="searchResult.cargoInsuranceAmount">
						{{ searchResult.cargoInsuranceAmount | currency: 'USD' : 'symbol' : '1.0-0' }}
					</span>
					<span *ngIf="!searchResult.cargoInsuranceAmount">N/A</span>
				</div>
			</td>
			<td #frequencyContainer fxFlex="21" fxLayoutAlign="start center">
				<div
					class="full-width ellipsis"
					fxLayoutAlign="space-between center"
					*ngIf="accountSettings.FREQUENCY_ENABLED && searchResult.isLane"
					[style.fontWeight]="filters.column === RANGE_FILTERS.SORT.FREQUENCY ? 'bold' : 'normal'"
					[ngStyle]="{
						'max-width':
							'calc(' +
							(frequencyContainer?.offsetWidth ? frequencyContainer.offsetWidth - 8 : 200) +
							'px)'
					}"
				>
					<span> Frequency: </span>
					<span>
						{{
							!utilService.isNullOrUndefined(searchResult.frequency) ? searchResult.frequency : ''
						}}
						{{
							!utilService.isNullOrUndefined(searchResult.frequency) &&
							isFrequencyValidNumber(searchResult.frequency)
								? '/ weekly'
								: ''
						}}
					</span>
				</div>
			</td>

			<td fxFlex="20" fxLayoutAlign="start center">
				<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
					<span>Last Load: </span>
					<span *ngIf="searchResult.rateUpdatedAt">
						&nbsp;
						{{ searchResult.rateUpdatedAt | date: 'MM/dd/yyyy' }}
					</span>
				</div>
			</td>
			<td fxFlex="11" fxLayoutAlign="start center">
				<mat-spinner
					*ngIf="utilService.isNullOrUndefined(searchResult.notesCount)"
					[diameter]="11"
					strokeWidth="1"
				></mat-spinner>

				<div *ngIf="!utilService.isNullOrUndefined(searchResult.notesCount)" class="full-width">
					<div
						*ngIf="searchResult.notesCount > 0"
						fxLayoutAlign="space-between center"
						class="full-width"
					>
						<span>
							{{ searchResult.notesCount + ' Note' + (searchResult.notesCount > 1 ? 's' : '') }}
						</span>
						<span fxLayoutAlign="start center">
							<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
						</span>
					</div>
					<div
						*ngIf="searchResult.notesCount == 0"
						fxLayoutAlign="space-between center"
						class="full-width"
					>
						<span class="primary-text">No Notes</span>
						<span fxLayoutAlign="start center">
							<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
						</span>
					</div>
				</div>
			</td>
		</tr>

		<tr class="font-size-14 mt-3" fxLayout="row">
			<td fxFlex fxLayoutAlign="start center">
				<span>PU: {{ searchResult.powerUnits || 'N/A' }} </span>
				<span>&nbsp;/ T: {{ searchResult.trailers || 'N/A' }} </span>
				<span>&nbsp;/ D: {{ searchResult.drivers || 'N/A' }} </span>
				<span>&nbsp;/ C: {{ searchResult.carrierContactsCount || 'N/A' }} </span>
			</td>
			<td fxFlex="20" fxLayoutAlign="start center">
				<div class="full-width p-r-1" fxLayoutAlign="space-between center">
					<span>Violations: </span>
					<span>N/A</span>
				</div>
			</td>
			<td fxFlex="21" fxLayoutAlign="start center">
				<div class="full-width" fxLayoutAlign="space-between center">
					<span>
						<span *ngIf="!utilService.isNullOrUndefined(searchResult.originDeadhead)">
							DH-O: {{ searchResult.originDeadhead | number: '1.0-0' }}
						</span>
						<span *ngIf="searchResult.originDeadhead && searchResult.destinationDeadhead">
							&nbsp;/&nbsp;
						</span>
					</span>
					<span>
						<span class="font-size-14">
							<span>DH-D: </span>
							<span *ngIf="!utilService.isNullOrUndefined(searchResult.destinationDeadhead)">
								{{ searchResult.destinationDeadhead | number: '1.0-0' }}
							</span>
							<span *ngIf="utilService.isNullOrUndefined(searchResult.destinationDeadhead)">
								N/A
							</span>
						</span>
					</span>
				</div>
			</td>
			<td fxFlex="20" fxLayoutAlign="start center">
				<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
					<span>Last Rate:</span>
					<span
						*ngIf="IS_NOT_NULL_OR_UNDEFINED(searchResult.rate)"
						[matTooltipDisabled]="!searchResult.ratePickupDate"
						matTooltip="Pickup Date of the load Rate: {{ DATE_MDY(searchResult.ratePickupDate) }}"
						matTooltipClass="custom-tooltip"
					>
						{{ searchResult.rate | currency: 'USD' : 'symbol' : '1.0-0' }}
					</span>
					<span *ngIf="IS_NULL_OR_UNDEFINED(searchResult.rate)"> N/A </span>
				</div>
			</td>
			<td fxFlex="11" fxLayoutAlign="start center">
				<div class="full-width" *ngIf="productsService.PROJECT_CARRIERS">
					<div
						fxLayoutAlign="space-between center"
						class="full-width dropdown"
						*ngIf="searchResult.projectCount > 0"
					>
						<span>
							{{ searchResult.projectCount }}
							{{ searchResult.projectCount > 1 ? 'Projects' : 'Project' }}
						</span>
						<span fxLayoutAlign="start center">
							<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
						</span>
					</div>

					<div
						fxLayoutAlign="space-between center"
						class="full-width"
						*ngIf="searchResult.projectCount == 0"
					>
						<span class="primary-text">No Projects</span>
						<span fxLayoutAlign="start center">
							<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
						</span>
					</div>
				</div>
			</td>
		</tr>
	</table>
</mat-panel-title>
